import { Tag, TagLabel, Wrap } from "@chakra-ui/react";

import { TagDictionary } from "@bcasmart/doxecure-commons/doxecureTypes";

interface TagFilterBarProps {
    tags: TagDictionary;
    selected: Set<string>;
    onToggle: (key: string) => void;
}

export const TagFilterBar = (props: TagFilterBarProps) => {
    const { tags, selected, onToggle } = props;

    return (
        <Wrap spacing={2}>
            {Object.entries(tags).map(([key, tag]) => {
                const isSelected = selected.has(key);
                return (
                    <Tag key={key} height="2.5rem" cursor="pointer" backgroundColor={isSelected ? tag.color : "transparent"}  color={isSelected ? "white" : tag.color}
                         borderWidth="1px" borderRadius="xl"  borderColor={tag.color}
                         onClick={() => onToggle(key)}
                    >
                        <TagLabel>{tag.name}</TagLabel>
                    </Tag>
                );
            })}
        </Wrap>
    );
}